export const SET_CHANGE_NAME = 'auth/SET_REGISTER';
export const SET_CHANGE_EMAIL = 'auth/SET_REGISTER';
export const SET_JWT_EXPIRATION = 'auth/SET_REGISTER';
